import styled from '@emotion/styled/macro';
import { colors, views } from '../../common/styles/theme.styles';


export const PageWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #f2f3f5;
    height: 100%;
    overflow: hidden;
`;

export const EntitiesPageContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: ${colors.lightGray1};
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 1fr 400px;
  grid-template-areas: 
    "header panel"
    "graph panel"
    "graph guide";
  grid-row-gap: 16px;
  padding: 24px 24px 0 0;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 1130px) {
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr;
    grid-template-areas: 
      "header"
      "graph";
  }

  ${views.mobile} {
    display: flex;
    padding: 0;
  }
`;

export const EntitiesHeader = styled.div`
  grid-area: header;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  background: #FFFFFF;
  border: 1px solid ${colors.gray3};
  border-radius: 20px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.04);
  height: 64px;
  z-index: 10;
`;

export const HeaderTitle = styled.h1`
  margin: 0;
  font-family: Circular;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.2;
  color: ${colors.darkGray1};
  flex: 1;
`;

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const EntitiesMobileHeader = styled.div`
    position: ${props => props.isHeaderFixed ? `fixed` : `relative`};
    top: 0;
    background-color: #111213;
    z-index: 2;
    width: 100%;
    min-height: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    padding: 0 24px 0 0;
`;

export const MobileHeaderTitle = styled.div`
  color: #fff;
  font-size: 18px;
  font-weight: 450;
  font-family: Circular;
  flex: 1;
`;

export const MobileHeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MobileAddButton = styled.button`
  height: 36px;
  padding: 0 12px;
  font-size: 14px;
  background-color: transparent;
  color: #fff;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-family: Circular;
  font-weight: 500;
  border-radius: 12px;
  border: 1px solid #3B3F46;
`;

export const MobileThreeDotsButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  border-radius: 50%;
  color: #fff;
  border: 1px solid #3B3F46;
  border-radius: 12px;
  svg {
    display: flex;
    align-items: center;
    justify-content: center;
    circle {
      fill: #fff;
    }
  }
`;

export const GraphContainer = styled.div`
  grid-area: graph;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: #FFFFFF;
  
  .react-flow__viewport {
    background: ${colors.lightGray1};
  }
  
  .react-flow__edge {
    stroke: ${colors.gray2};
    stroke-width: 2px;
  }
  
  .react-flow__edge-path {
    stroke: ${colors.gray2};
    stroke-width: 2px;
  }
  
  .react-flow__edge.selected {
    stroke: #546481;
  }
  
  .react-flow__node.selected {
    /* Completely override ReactFlow's default selection styling */
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
  }
  
  /* Override any ReactFlow selection styling that might be applied */
  .react-flow__node.react-flow__node-selected {
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
  }
  
  /* Override ReactFlow's default node selection */
  .react-flow__node[data-selected="true"] {
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
  }
  
  .react-flow__connection-line {
    stroke: #546481;
    stroke-width: 2px;
    stroke-dasharray: 5,5;
  }
  
  .react-flow__controls {
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
    border: 1px solid ${colors.gray3};
    border-radius: 8px;
    overflow: hidden;
    
    button {
      background: #FFFFFF;
      border: none;
      border-bottom: 1px solid ${colors.gray3};
      padding: 8px;
      
      &:last-child {
        border-bottom: none;
      }
      
      &:hover {
        background: ${colors.lightGray2};
      }
      
      svg {
        fill: ${colors.darkGray1};
      }
    }
  }
  
  .react-flow__minimap {
    background: #FFFFFF;
    border: 1px solid ${colors.gray3};
    border-radius: 8px;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
    
    .react-flow__minimap-mask {
      fill: rgba(167, 182, 194, 0.2);
    }
  }
  
  .react-flow__background {
    background: ${colors.lightGray1};
  }
`;

export const EntityPanel = styled.div`
  grid-area: panel;
  width: 400px;
  height: 100%;
  background: #FFFFFF;
  border: 1px solid ${colors.gray3};
  border-radius: 20px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  z-index: 10;
`;

export const EntityDetailView = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const EntityDetailHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${colors.gray3};
  background: #FFFFFF;
  
  h3 {
    margin: 0 0 4px;
    font-family: Circular;
    font-weight: 600;
    font-size: 18px;
    line-height: 1.2;
    color: ${colors.darkGray1};
  }
  
  p {
    margin: 0;
    font-family: Circular;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.4;
    color: ${colors.darkGray3};
  }
`;

export const EntityDetailContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
`;

export const EntityActions = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid ${colors.gray3};
  border-radius: 6px;
  background: #FFFFFF;
  color: ${colors.darkGray1};
  font-family: Circular;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${colors.lightGray2};
    border-color: ${colors.gray2};
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ItemsSection = styled.div`
  margin-bottom: 24px;
  
  h4 {
    margin: 0 0 12px;
    font-family: Circular;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.2;
    color: ${colors.darkGray1};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

export const ItemCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #FFFFFF;
  border: 1px solid ${colors.gray3};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${colors.lightGray2};
    border-color: ${colors.gray2};
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  }
`;

export const ItemInfo = styled.div`
  flex: 1;
  min-width: 0;
  
  h5 {
    margin: 0 0 2px;
    font-family: Circular;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.2;
    color: ${colors.darkGray1};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  p {
    margin: 0;
    font-family: Circular;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.2;
    color: ${colors.darkGray3};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 16px;
  background: transparent;
  border: none;
  color: ${colors.darkGray3};
  font-family: Circular;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    color: ${colors.darkGray1};
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const EmptyStateMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: ${colors.darkGray3};
  
  h4 {
    margin: 0 0 8px;
    font-family: Circular;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.2;
    color: ${colors.darkGray1};
  }
  
  p {
    margin: 0;
    font-family: Circular;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.4;
    color: ${colors.darkGray3};
  }
`;

export const BottomControlsContainer = styled.div`
  position: absolute;
  bottom: 24px;
  right: 0;
  left: auto;
  transform: none;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 10;
  ${({ isThreshold }) => isThreshold && `
    right: 16px;
  `}
`;

export const GuideArea = styled.div`
  grid-area: guide;
  display: flex;
  width: 100%;
  align-items: center;
`;

